export default __webpack_public_path__ + "static/media/eclipse.62dfd01a.svg";